import { useContext, useMemo } from "react";
import CheckUpContext from "../../context/check-up";
import CheckUpStep1 from "./check-up-step-1";
import CheckUpStep2 from "./check-up-step-2";
import CheckUpStep3 from "./check-up-step-3";
import CheckUpStep4 from "./check-up-step-4";
import classNames from "classnames";
import useCheckUpDeleteMutation from "../../hooks/mutations/useCheckupDeleteMutation";
import useCheckUpUpdateMutation from "../../hooks/mutations/useCheckupUpdateMutation";
import useCheckUpCreateMutation from "../../hooks/mutations/useCheckupCreateMutation";

const CheckUpSurvey = ({ discardModal, setDiscardModal }) => {
  const { path, survey, labels, currentRequest, currentSectionIndex } = useContext(CheckUpContext);

  // const currentSectionIndex = 0;
  const section = useMemo(
    () => survey?.definition?.sections?.find((section) => section.id === path?.slice(-1)?.[0]),
    [path, survey]
  );

  const closeModal = () => setDiscardModal(false);

  const { mutateAsync: asyncDeleteRequest, isError, reset } = useCheckUpDeleteMutation(closeModal);

  const { mutateAsync: asyncUpdateRequest, isError: isUpdateError } =
    useCheckUpUpdateMutation(closeModal);

  const { mutateAsync: asyncCreateRequest, isError: isCreateError } =
    useCheckUpCreateMutation(closeModal);

  const deleteObject = {
    deleteRequest: async (currentRequest) => {
      await asyncDeleteRequest({ request: currentRequest });
    },
    isError: isError,
    reset: reset,
  };

  const updateObject = {
    updateRequest: async (currentRequest, formData, formWatch, _lastCompletedStep) => {
      await asyncUpdateRequest({
        survey,
        request: currentRequest,
        formData,
        values: formWatch,
        // email: formWatch[survey?.definition?.sections[0].questions[6].id],
        // phone: formWatch[survey?.definition?.sections[0].questions[4].id],
        // lastCompletedStep,
      });
    },
    isError: isUpdateError,
  };

  const createObject = {
    createRequest: async (formData, formWatch, _lastCompletedStep) => {
      await asyncCreateRequest({
        survey,
        formData,
        values: formWatch,
        // email: formWatch[survey?.definition?.sections[0].questions[6].id],
        // phone: formWatch[survey?.definition?.sections[0].questions[4].id],
        // lastCompletedStep,
      });
    },
    isError: isCreateError,
  };

  return (
    <div
      className={classNames("wrapper wrapper--app", currentSectionIndex !== 2 && "wrapper-small")}
    >
      {(currentRequest?.status === "DRAFT" || currentRequest === "new") && (
        <>
          <span className="app-content__step">
            {labels?.WELFARE_STEP || "Step"} {path.length}
          </span>
          <div className="app-content__title-wrapper">
            <h2 className="app-content__title">{section?.label}</h2>
          </div>
        </>
      )}
      {section?.description && (
        <div
          className="app-content__text"
          dangerouslySetInnerHTML={{
            __html: section?.description,
          }}
        />
      )}
      {
        {
          0: (
            <CheckUpStep1
              discardModal={discardModal}
              setDiscardModal={setDiscardModal}
              deleteObject={deleteObject}
              updateObject={updateObject}
              createObject={createObject}
            />
          ),
          1: (
            <CheckUpStep2
              discardModal={discardModal}
              setDiscardModal={setDiscardModal}
              deleteObject={deleteObject}
              updateObject={updateObject}
            />
          ),
          2: (
            <CheckUpStep3
              discardModal={discardModal}
              setDiscardModal={setDiscardModal}
              deleteObject={deleteObject}
              updateObject={updateObject}
            />
          ),
          3: (
            <CheckUpStep4
              discardModal={discardModal}
              setDiscardModal={setDiscardModal}
              deleteObject={deleteObject}
            />
          ),
        }[currentSectionIndex]
      }
    </div>
  );
};

export default CheckUpSurvey;
